import * as React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Box,
  Badge,
  Drawer,
  List,
  ListItem,
  ListItemText
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import MenuIcon from "@mui/icons-material/Menu";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import "./Header.css";
import logo from "./images/logo.png"
// import { useLocation } from "react-router-dom";

function Header() {
  const navigate = useNavigate();
//  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = React.useState(false);
  const [cartCount, setCartCount] = React.useState(0);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  // ✅ Toggle Drawer
  const toggleDrawer = () => {
    setMobileOpen(!mobileOpen);
  };

  // ✅ Fetch cart count
  const fetchCartCount = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      setCartCount(0);
      return;
    }

    try {
      const res = await fetch("https://citrine-backend-0hws.onrender.com/api/cart", {
        headers: { Authorization: token }
      });

      const data = await res.json();

      const totalQty = data.reduce(
        (sum, item) => sum + item.quantity,
        0
      );

      setCartCount(totalQty);
    } catch (err) {
      console.error("Cart fetch error:", err);
    }
  };

  // ✅ Logout
  const handleLogout = () => {
    localStorage.removeItem("token");
    window.dispatchEvent(new Event("authChanged"));
    setIsLoggedIn(false);
    navigate("/login");
  };

  // ✅ Sync auth + cart
  React.useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("token");
      setIsLoggedIn(!!token);

      if (token) {
        fetchCartCount();
      } else {
        setCartCount(0);
      }
    };

    checkAuth();

    window.addEventListener("authChanged", checkAuth);
    window.addEventListener("cartUpdated", fetchCartCount);

    return () => {
      window.removeEventListener("authChanged", checkAuth);
      window.removeEventListener("cartUpdated", fetchCartCount);
    };
  }, []);

  // ✅ Drawer Content
  const drawer = (
    <Box onClick={toggleDrawer} className="drawer">
      <List>
        <ListItem button onClick={() => navigate("/")}>
          <ListItemText primary="Home" />
        </ListItem>

        <ListItem button onClick={() => navigate("/about")}>
          <ListItemText primary="About" />
        </ListItem>

        <ListItem button onClick={() => navigate("/contact")}>
          <ListItemText primary="Contact" />
        </ListItem>

        {!isLoggedIn ? (
          <>
            <ListItem button onClick={() => navigate("/login")}>
              <ListItemText primary="Login" />
            </ListItem>

            <ListItem button onClick={() => navigate("/register")}>
              <ListItemText primary="Register" />
            </ListItem>
          </>
        ) : (
          <ListItem button onClick={handleLogout}>
            <ListItemText primary="Logout" />
          </ListItem>
        )}
      </List>
    </Box>
  );

  return (
    <>
    <AppBar position="fixed" className="navbar">
      <Toolbar className="toolbar">

        {/* Mobile Menu */}
        {isMobile && (
          <IconButton onClick={toggleDrawer}>
            <MenuIcon />
          </IconButton>
        )}

        {/* Logo */}
    <Box className="logo-container" onClick={() => navigate("/")}>
  <img src={logo} alt="logo" className="logo-img" />

    <Typography variant="h6" className="logo-text">
      Citrine Enterprise
    </Typography>
 
</Box>

        {/* Desktop Nav */}
        {!isMobile && (
          <Box className="nav-links">
            <Button onClick={() => navigate("/")}>Home</Button>
            <Button onClick={() => navigate("/about")}>About</Button>
            <Button onClick={() => navigate("/contact")}>Contact</Button>
          </Box>
        )}

        {/* Right Section */}
        <Box className="right-section">

          {/* Cart */}
          <IconButton onClick={() => navigate("/cart")}>
            <Badge badgeContent={cartCount} color="error" showZero>
              <ShoppingCartIcon />
            </Badge>
          </IconButton>

          {/* Desktop Auth */}
          {!isMobile && (
            <>
              {!isLoggedIn ? (
                <>
                  <Button onClick={() => navigate("/login")}>
                    Login
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => navigate("/register")}
                  >
                    Register
                  </Button>
                </>
              ) : (
                <Button color="error" onClick={handleLogout}>
                  Logout
                </Button>
              )}
            </>
          )}
        </Box>
      </Toolbar>

      {/* Drawer */}
      <Drawer anchor="left" open={mobileOpen} onClose={toggleDrawer}>
        {drawer}
      </Drawer>
    </AppBar>

    {/* {isMobile && location.pathname !== "/cart" && (
  <Box
    sx={{
      position: "fixed",
      bottom: 20,
      right: 20,
      zIndex: 1300,
    }}
  >
    <Button
      onClick={() => navigate("/cart")}
      sx={{
        minWidth: 0,
        width: 45,
        height: 45,
        borderRadius: "50%",
        p: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)", // modern gradient
        color: "#fff",
        boxShadow: "0 6px 15px rgba(0,0,0,0.3)",
        transition: "all 0.3s ease",
        "&:hover": {
          transform: "scale(1.1)",  // grows slightly on hover
          boxShadow: "0 8px 20px rgba(48, 42, 42, 0.4)",
          bgcolor: "linear-gradient(135deg, #2575fc 0%, #6a11cb 100%)"
        }
      }}
    >
      <Badge badgeContent={cartCount} color="error" showZero>
        <ShoppingCartIcon fontSize="large" />
      </Badge>
    </Button>
  </Box>
)} */}
      </>
  );
}

export default Header;